import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import PictureComponent from "components/core/picture/picture-component";
import { XS, XS_ML } from "constants/sizes";
import { StyledProductTabTitle } from "./product-tab-title.scss";
import classNames from "classnames";
const ProductTabTitle = (props)=>{
    const { title, body, productImage, selectedProductImage, isSelected } = props;
    return /*#__PURE__*/ _jsxs(StyledProductTabTitle, {
        className: classNames("product-title", {
            "selected-logo": isSelected,
            "logo-exists": selectedProductImage
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "product-logo-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-logo",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: productImage
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "selected-product-logo",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: selectedProductImage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "product-tab-title-text",
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        titleSize: XS_ML,
                        title: title,
                        titleClassName: "product-tab-title"
                    }),
                    /*#__PURE__*/ _jsx(Paragraph, {
                        body: body,
                        textSize: XS
                    })
                ]
            })
        ]
    });
};
export default ProductTabTitle;
